/**
 * @file: haptics.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

export function isHapticsAvailable() {
  return 'vibrate' in navigator;
}

export namespace SafeHaptics {
  export function selection() {
    if (isHapticsAvailable()) {
      try {
        navigator.vibrate(5);
      } catch {}
    }
  }

  export function impact(style: 'light' | 'medium' | 'heavy' = 'medium') {
    if (isHapticsAvailable()) {
      try {
        if (style === 'light') {
          navigator.vibrate(10);
        } else if (style === 'medium') {
          navigator.vibrate(20);
        } else {
          navigator.vibrate([30, 10, 30]);
        }
      } catch {}
    }
  }

  export function notification(
    style: 'success' | 'warning' | 'error' = 'success',
  ) {
    if (isHapticsAvailable()) {
      try {
        if (style === 'success') {
          navigator.vibrate([10, 50, 10]);
        } else if (style === 'warning') {
          navigator.vibrate([30, 40, 30]);
        } else {
          navigator.vibrate([40, 30, 40, 30, 40]);
        }
      } catch {}
    }
  }

  export function notificationError() {
    notification('error');
  }
}
